var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadCrumbSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73242 3.10352L0.826172 0.496094V1.49805L5.80078 3.61328L0.826172 5.73438V6.70117L6.73242 4.09375V3.10352Z",
    fill: "#B3BAC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadCrumbSeperator);
export default __webpack_public_path__ + "static/media/breadCrumbSeperator.89957188.svg";
export { ForwardRef as ReactComponent };